import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  HttpClient,
  HttpResponse,
  HttpParams,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root',
})
export class RecommendationService {
  url = environment.api_url;
  recommendationObj;
  hg_accountId;
  userName;
  getRecommendation = new EventEmitter();
  signupProduct;
  ssnFailedText;
  enrollmentOrderDetails;
  ssnFailedEnergyProviders = [];
  private messageSource = new BehaviorSubject({});
  currentMessage = this.messageSource.asObservable();

  constructor(private http: HttpClient, private route: ActivatedRoute) {
    this.hg_accountId = window.location.href.split('/').pop();
    this.userName = localStorage.getItem('userName');
  }

  public getRecommendationRes() {
    this.hg_accountId = window.location.href.split('/').pop();
    const body = new HttpParams().append('hg_accountId', this.hg_accountId);

    this.http
      .get(this.url + '/recommendation', { params: body })
      .subscribe((res: any) => {
        const result = res;
        this.recommendationObj = result;
        this.getRecommendation.emit({ recommendationObj: result });
        this.userName = !_.isEmpty(result)
          ? result.displayname_questn
          : this.userName
          ? this.userName
          : 'Sam';
        localStorage.setItem('userName', this.userName);
        return result;
      });
  }

  public messageService(message: {}) {
    this.messageSource.next(message);
  }
}
